/**
 * Watch Finder — same scoring as lib/finder.ts in the Next.js app.
 */
(function () {
  var OCCASION = [
    { value: "everyday", label: "On the go", hint: "G10 on a NATO strap" },
    { value: "standout", label: "Night out", hint: "Leather or steel 4A" },
    { value: "gift", label: "A gift", hint: "Something we can ship now" },
  ];
  var STRAP = [
    { value: "nylon", label: "Nylon NATO", hint: "The G10 series" },
    { value: "leather", label: "Leather", hint: "Maua, BOLD, Reloj" },
    { value: "steel", label: "Steel", hint: "Blom" },
    { value: "any", label: "Doesn’t matter", hint: "Surprise me" },
  ];
  var BUDGET = [
    { value: "under-100", label: "Under $100", hint: "Most of the G10s" },
    { value: "100-150", label: "$100–$150", hint: "G&B, Black Gold, some 4A" },
    { value: "150-plus", label: "$150 and up", hint: "The 4A watches" },
    { value: "any", label: "Any budget", hint: "Show me everything" },
  ];

  function inferStrap(product) {
    var hay = [
      product.title,
      product.body_html,
      product.product_type,
      (product.tags || []).join(" "),
    ]
      .join(" ")
      .toLowerCase();
    if (hay.indexOf("leather") !== -1) return "leather";
    if (hay.indexOf("stainless") !== -1 || hay.indexOf("steel") !== -1) return "steel";
    if (
      hay.indexOf("nylon") !== -1 ||
      hay.indexOf("nato") !== -1 ||
      String(product.title || "")
        .toUpperCase()
        .indexOf("G10") !== -1
    ) {
      return "nylon";
    }
    return "other";
  }

  function inferLine(product) {
    var type = String(product.product_type || "").toLowerCase();
    if (type.indexOf("umbrella") !== -1 || type.indexOf("sunglass") !== -1) {
      return "accessory";
    }
    var title = String(product.title || "").toUpperCase();
    if (title.indexOf("4A") === 0 || title.indexOf("4A ") !== -1) return "4a";
    if (title.indexOf("G10") !== -1 || title.indexOf("BLACK GOLD") !== -1) return "g10";
    return "other";
  }

  function money(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
    }).format(n);
  }

  function scoreWatch(product, answers) {
    if (product.line === "accessory") return -1;
    if (!product.available) return 0;
    var score = 1;
    if (answers.occasion === "everyday" && product.line === "g10") score += 4;
    if (answers.occasion === "standout" && product.line === "4a") score += 4;
    if (answers.occasion === "gift") score += 2;
    if (answers.strap && answers.strap !== "any") {
      if (product.strap === answers.strap) score += 4;
      else score -= 2;
    }
    if (answers.budget === "under-100" && product.price < 100) score += 3;
    if (answers.budget === "100-150" && product.price >= 100 && product.price <= 150) {
      score += 3;
    }
    if (answers.budget === "150-plus" && product.price >= 150) score += 3;
    if (product.line === "g10" && String(product.title).indexOf("NATO") !== -1) score += 0.5;
    return score;
  }

  function normalize(raw) {
    var prices = (raw.variants || []).map(function (v) {
      return Number(v.price);
    });
    var available = (raw.variants || []).some(function (v) {
      return v.available;
    });
    return {
      id: raw.id,
      title: raw.title,
      handle: raw.handle,
      image: raw.images && raw.images[0] ? raw.images[0].src : null,
      available: available,
      variants: (raw.variants || []).map(function (v) {
        return { id: v.id, available: v.available, price: Number(v.price) };
      }),
      price: prices.length ? Math.min.apply(null, prices) : 0,
      strap: inferStrap(raw),
      line: inferLine(raw),
    };
  }

  function recommend(products, answers, limit) {
    limit = limit || 3;
    return products
      .map(function (product) {
        return { product: product, score: scoreWatch(product, answers) };
      })
      .filter(function (entry) {
        return entry.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.product.price - b.product.price;
      })
      .slice(0, limit)
      .map(function (entry) {
        return entry.product;
      });
  }

  function renderOptions(container, options, selected) {
    container.innerHTML = options
      .map(function (option) {
        var on = selected === option.value ? " is-on" : "";
        return (
          '<button type="button" class="fa-opt' +
          on +
          '" data-value="' +
          option.value +
          '">' +
          option.label +
          '<span class="fa-finder__hint">' +
          option.hint +
          "</span></button>"
        );
      })
      .join("");
  }

  function init(root) {
    var answers = { occasion: null, strap: null, budget: null };
    var catalog = [];
    var occasionEl = root.querySelector('[data-finder-step="occasion"]');
    var strapEl = root.querySelector('[data-finder-step="strap"]');
    var budgetEl = root.querySelector('[data-finder-step="budget"]');
    var resultsEl = root.querySelector("[data-finder-results]");
    var cardsEl = root.querySelector("[data-finder-cards]");
    var emptyEl = root.querySelector("[data-finder-empty]");

    renderOptions(occasionEl, OCCASION, null);
    renderOptions(strapEl, STRAP, null);
    renderOptions(budgetEl, BUDGET, null);

    function redraw() {
      renderOptions(occasionEl, OCCASION, answers.occasion);
      renderOptions(strapEl, STRAP, answers.strap);
      renderOptions(budgetEl, BUDGET, answers.budget);
      var complete = answers.occasion && answers.strap && answers.budget;
      if (!complete) {
        resultsEl.hidden = true;
        return;
      }
      resultsEl.hidden = false;
      var matches = recommend(catalog, answers, 3);
      if (!matches.length) {
        emptyEl.hidden = false;
        cardsEl.innerHTML = "";
        return;
      }
      emptyEl.hidden = true;
      cardsEl.innerHTML = matches
        .map(function (product) {
          var variant =
            product.variants.filter(function (item) {
              return item.available;
            })[0] || product.variants[0];
          var img = product.image
            ? '<img class="fa-finder__photo" src="' +
              product.image +
              '" alt="' +
              product.title.replace(/"/g, "&quot;") +
              '">'
            : "";
          var action = variant
            ? '<a class="fa-finder__add" href="/cart/' + variant.id + ':1">Add to bag</a>'
            : '<a class="fa-finder__add" href="/products/' +
              product.handle +
              '">View watch</a>';
          return (
            '<article class="fa-finder__card">' +
            img +
            '<div class="fa-finder__body"><strong>' +
            product.title +
            '</strong><p class="fa-finder__price">' +
            money(product.price) +
            "</p>" +
            action +
            "</div></article>"
          );
        })
        .join("");
    }

    root.addEventListener("click", function (event) {
      var button = event.target.closest(".fa-opt");
      if (!button) return;
      var step = button.parentElement.getAttribute("data-finder-step");
      if (!step) return;
      answers[step] = button.getAttribute("data-value");
      redraw();
    });

    fetch("/products.json?limit=250")
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        catalog = (data.products || []).map(normalize);
        redraw();
      })
      .catch(function () {
        catalog = [];
      });
  }

  document.querySelectorAll("[data-fa-finder]").forEach(init);
})();
